import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';
import onboarding from './onboarding';
import common from './common';
import transactions from './transactions';
import login from './login';
import logged from './logged';
import users from './users';
import andes from './andes';
import promotions from './promotions';
import config from './config';
import advancements from './advancements';
import reports from './reports';

export default (history) =>
  combineReducers({
    router: connectRouter(history),
    common,
    onboarding,
    login,
    transactions,
    logged,
    users,
    andes,
    promotions,
    config,
    advancements,
    reports,
  });
